<template>
  <div class="emtype" ref="qwcontent">
	  <div class="emtype_left">
	  	<img src="@/static/img/noWifi1.png" alt="">
	  </div>
	  <div class="emtype_right">
	  	<div class="emtype_rmain">
	  		<div class="emtypeImg">
				<img src="@/static/img/404.png" alt="">
				<img src="../static/img/404Icon.png" alt="">
			</div>
			<div>您访问的页面已不存在！</div>
			<div>NO SIGNAL HERE</div>
			<div class="back" @click="back">
				<img src="@/static/icons/back2.png" alt="">
				<span>返回</span>
			</div>
	  	</div>
	  </div>
  </div>
</template>

<script>
export default {
	created(){
			this.$emit('changeIsShow','false');
		},
	mounted() {
	  this.fullHeight= `${document.documentElement.clientHeight}`;//默认值
	  const that = this
	  window.onresize = () => {
	    return (() => {
	      window.fullHeight = document.documentElement.clientHeight
	      that.fullHeight = window.fullHeight
	    })()
	  }
	},
	watch:{
		// 如果 `fullHeight ` 发生改变，这个函数就会运行
		fullHeight :function(val) {
		  if(!this.timer) {
		    this.fullHeight = val
		    this.changeFixed(this.fullHeight)
		    this.timer = true
		    let that = this
		    setTimeout(function (){//频繁触发 resize 函数，会导致页面很卡
		      that.timer = false
		    },400)
		  }
		}
	},
  methods: {
    back() {
      this.$router.go(-1);
    },
	changeFixed(fullHeight){                        //动态修改样式
	    this.$refs.qwcontent.style.height = fullHeight+'px';
	},
  },
  data() {
  	return {
		fullHeight: ''
	}
  },
};
</script>

<style scoped>
	.emtype{
		min-width: 1200px;
		display: flex;
		align-items: center;
	}
	.emtype .emtype_left {
		width: 40vw;
		background: #2D73FE;
		height: 100%;
		display: flex;
	}
	.emtype .emtype_left img {
		width: 100%;
		height: 80%;
		margin: auto;
	}
	.emtype .emtype_right {
		width: 60vw;
		display: flex;
	}
	.emtype_rmain {
		margin: auto;
		text-align: center;
	}
	.emtype_rmain .emtypeImg {
		width: 24vw;
		height: 36vh;
		position: relative;
	}
	.emtype_rmain .emtypeImg img:first-child {
		width: 100%;
		height: 100%;
	}
	.emtype_rmain .emtypeImg img:last-child {
		position: absolute;
		width: 3.8vw;
		height: 5vh;
		left: 7.9vw;
		bottom: 2.6vh;
	}
	.emtype div:nth-child(2) {
		color: #333333;
		font-size:calc(100vw * 22 / 1920);
		margin: auto;
	}
	.emtype div:nth-child(3) {
		color: #999999;
		font-size:calc(100vw * 18 / 1920);
		margin-top: 1vh;
	}
	.emtype div:nth-child(4) {
		text-align: center;
		border: #D5D5D5 1px solid;
		color: #D5D5D5;
		font-size:calc(100vw * 18 / 1920);
		border-radius: 30px;
		line-height: 6vh;
		width: 11.8vw;
		margin: 3vh auto 0;
	}
	.emtype div:nth-child(4):hover {
		border: #2D73FE 1px solid;
		cursor: pointer;
	}
	.emtype div:nth-child(4) img {
		margin-right: 0.3vw;
		width: 1.5vw;
		height: 2vh;
	}
</style>

